import React, { Component, PropTypes } from 'react';

class FlexBox extends Component {
  static displayName = 'FlexBox';

  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    reverse: PropTypes.bool,
    column: PropTypes.bool,
    row: PropTypes.bool,
    justifyContent: PropTypes.string,
    wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
    alignItems: PropTypes.oneOf([
      'stretch',
      'flex-start',
      'center',
      'flex-end',
      'base-line'
    ]),
    alignContent: PropTypes.oneOf([
      'stretch',
      'flex-start',
      'center',
      'flex-end',
      'base-line',
      'space-between',
      'space-around'
    ]),
    width: PropTypes.string,
    height: PropTypes.string,
    grow: PropTypes.number,
    shrink: PropTypes.number,
    alignSelf: PropTypes.oneOf([
      'stretch',
      'flex-start',
      'center',
      'flex-end',
      'base-line'
    ])
  };

  static defaultProps = {
    reverse: false,
    column: false,
    row: true,
    justifyContent: 'flex-start',
    wrap: 'nowrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    grow: 1,
    shrink: 1,
    alignSelf: 'stretch'
  };

  getStyle() {
    const {
      style,
      column,
      justifyContent,
      wrap,
      alignItems,
      alignContent,
      width,
      height,
      grow,
      shrink,
      alignSelf
    } = this.props;
    const direction = column ? 'column' : 'row';
    const reverse = reverse ? '-reverse' : '';
    return Object.assign(
      {},
      {
        // flex: 1,
        display: 'flex',
        flexDirection: direction + reverse,
        justifyContent,
        flexWrap: wrap,
        alignItems,
        alignContent,
        width,
        height,
        flexGrow: grow,
        flexShrink: shrink,
        alignSelf
      },
      style
    );
  }

  render() {
    const { children, className } = this.props;
    return <div className={className} style={this.getStyle()}>{children}</div>;
  }
}

export default FlexBox;



// WEBPACK FOOTER //
// ./src/js/components/FlexBox.js